// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"555e2034","513":"543a576c","703":"8988c0b6","787":"ffdf2d69"}[chunkId] + ".chunk.js";
};